import { Instance, SnapshotOut, types, flow, getRoot } from "mobx-state-tree"
import { RootStoreModel } from "~models/root-store"
import { withEnvironment } from "../extensions/with-environment"

/**
 * 銀行列表 store
 */

export const BankStoreModel = types
  .model("BankStore")
  .props({
    bankList: types.map(types.string),
  })
  .extend(withEnvironment)
  .views(() => ({}))
  .actions((self) => {
    const { authStore, apiStore } = getRoot<Instance<typeof RootStoreModel>>(self)
    const setBankList = (deta) => {
      self.bankList = deta
    }

    const getBankList = flow(function* () {
      const token = authStore.getToken
      const res = yield apiStore.getBankList({ token })
      if (res?.bank) {
        setBankList(res.bank)
      }
    })

    return {
      getBankList,
      setBankList,
    }
  })

type BankStoreType = Instance<typeof BankStoreModel>
export interface BankStore extends BankStoreType {}
type BankStoreSnapshotType = SnapshotOut<typeof BankStoreModel>
export interface BankStoreSnapshot extends BankStoreSnapshotType {}
export const createBankStoreDefaultModel = () => types.optional(BankStoreModel, {})
